
import React from "react";
import { Card } from "flowbite-react";

const Cuenta = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-6">
      <Card className="w-full max-w-lg shadow-lg bg-white rounded-lg p-6">
        <h1 className="text-2xl font-bold text-center text-gray-800">👤 Manejar Cuenta</h1>
        <p className="text-center text-gray-600 mt-4">
          Aquí podrás gestionar tu perfil próximamente.
        </p>
      </Card>
    </div>
  );
};

export default Cuenta;
